module.exports = __webpack_public_path__ + "img/pic_sushe.c7b854e7.png";